import NacelleData from '../modules/data'
import NacelleCheckout from '../modules/checkout'
import NacelleStatus from '../modules/status'
import NacelleWishlist, { NacelleWishlistParams } from '../modules/wishlist'
import NacelleEvents, { NacelleEventsParams } from '../modules/events'
import { NacelleConnector } from '../connectors/nacelleConnector'
import NacelleStaticConnector from '../connectors/static/nacelleStaticConnector'
import NacelleGraphQLConnector from '../connectors/graphql/nacelleGraphQLConnector'

export interface NacelleClientParams {
  token: string
  id: string
  nacelleEndpoint: string
  eventsEndpoint?: string
  wishlistEndpoint?: string
  staticBasePath?: string
  locale?: string
  useStatic?: boolean
  debugMode?: boolean
  disableEvents?: boolean
}
export class NacelleClient {
  // Settings
  id: string
  token: string
  nacelleEndpoint: string
  useStatic: boolean
  debugMode: boolean
  defaultLocale: string

  // Modules
  data: NacelleData
  checkout: NacelleCheckout
  events: NacelleEvents
  status: NacelleStatus
  wishlist: NacelleWishlist

  constructor(params: NacelleClientParams) {
    if (typeof params.token === 'undefined' || params.token.length === 0) {
      throw new Error('Nacelle space token is required.')
    }

    if (typeof params.id === 'undefined' || params.id.length === 0) {
      throw new Error('Nacelle space id is required.')
    }

    if (
      typeof params.nacelleEndpoint === 'undefined' ||
      params.nacelleEndpoint.length === 0
    ) {
      throw new Error('Nacelle endpoint is required')
    }

    // Set defaults
    this.id = params.id
    this.token = params.token
    this.nacelleEndpoint = params.nacelleEndpoint
    this.useStatic =
      typeof params.useStatic !== 'undefined' ? params.useStatic : true
    this.debugMode =
      typeof params.debugMode !== 'undefined' ? params.debugMode : false
    this.defaultLocale =
      typeof params.locale !== 'undefined' ? params.locale : 'en-us'

    // Set up connectors
    let dataConnector = new NacelleConnector({
      locale: this.defaultLocale
    })

    const staticConnector = new NacelleStaticConnector({
      basePath: params.staticBasePath,
      locale: this.defaultLocale
    })

    const graphQLConnector = new NacelleGraphQLConnector({
      endpoint: this.nacelleEndpoint,
      spaceId: this.id,
      token: this.token,
      locale: this.defaultLocale
    })

    // Setup Data module
    if (this.useStatic) {
      dataConnector = staticConnector
    } else {
      dataConnector = graphQLConnector
    }

    this.data = new NacelleData({
      connector: dataConnector,
      locale: this.defaultLocale
    })

    // Setup Checkout Module
    this.checkout = new NacelleCheckout({
      connector: graphQLConnector
    })

    // Setup Status Module
    this.status = new NacelleStatus({
      connector: graphQLConnector
    })

    // Setup Events Module
    const eventParams: NacelleEventsParams = {}

    if (params.eventsEndpoint) {
      eventParams.endpoint = params.eventsEndpoint
    }

    if (params.disableEvents) {
      eventParams.disable = params.disableEvents
    }

    this.events = new NacelleEvents(eventParams)

    // Setup WishList module
    const wishlistParams: NacelleWishlistParams = {
      spaceId: this.id,
      token: this.token
    }

    if (params.wishlistEndpoint) {
      wishlistParams.endpoint = params.wishlistEndpoint
    }

    this.wishlist = new NacelleWishlist(wishlistParams)
  }
}
